import { render } from "./PageHero.vue?vue&type=template&id=35ecca5b&scoped=true"
import script from "./PageHero.vue?vue&type=script&lang=js"
export * from "./PageHero.vue?vue&type=script&lang=js"

import "./PageHero.vue?vue&type=style&index=0&id=35ecca5b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ecca5b"]])

export default __exports__